/**
 * @description i18n zh-CN
 * @author wangfupeng
 */

export default {
  videoModule: {
    delete: '删除视频',
    uploadVideo: '上传视频',
    insertVideo: '插入视频',
    videoSrc: '视频地址',
    videoSrcPlaceHolder: '视频文件 url 或第三方 <iframe>',
    videoPoster: '视频封面',
    videoPosterPlaceHolder: '封面图片 url',
    ok: '确定',
    editSize: '修改尺寸',
    width: '宽度',
    height: '高度',
  },
}
